import { createContext } from 'react';

export const IconContext = createContext<{ size: 'xs' | 'sm' | 'md' | 'lg' }>({
  size: 'md',
});
